import React from 'react'

import ControlButtonClose from "../../../../../core/gd-components/buttons/control-button/close"

type Props = {
    className?      : string
    titleClassName? : string

    height?         : number
    title           : any

    line2?          : any

    onClose?        : func
    onGoBack?       : func
}

export default function ModalV4HeaderWhite(props: Props) {

    const classes = Classes('header-white', props.className, {
        'with-go-back': !!props.onGoBack,
        'h60': props.height === 60,
        'h90': props.height === 90,
        // 'h100': props.height === 100,
    })

    const titleClasses = Classes("title", props.titleClassName, {
        'ui5-title-app-name': !props.titleClassName
    })

    const onClose = (e:React.MouseEvent) => {
        if (props.onClose) {
            props.onClose()
        } else {
            e.stopPropagation()
            gd.modal.hide()
        }
    }

    return (
        <div className={classes}>
            <div className={titleClasses}>{props.title}</div>
            <ControlButtonClose className   = "btn-close"
                                onClick     = {onClose}/>

            {props.onGoBack &&
                <div className  = "btn-go-back gd-btn-arrow-left-gray-22"
                     onClick    = {props.onGoBack}/>}

            {props.line2}
        </div>
    )
}